enum DefaultApiParameters {
  limit = 20,
  page = 1,
}

// Change default export when adding more enum
export default DefaultApiParameters;
